//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Preloader from '~/components/other/Preloader'
import MasterpieceSelect from '~/components/profile/MasterpieceSelect'
import ProfileDetail from "~/components/profile/ProfileDetail";
import Settings from "~/components/profile/Settings";
import Button from "~/components/other/Button";
import LeftAside from '~/components/other/LeftAside'
import ProfileAvatar from "~/components/profile/ProfileAvatar";
import ProfileMenu from "~/components/profile/ProfileMenu";
import SidebarAnchors from "~/components/other/SidebarAnchors";
import AchievementsModal from "~/components/profile/AchievementsModal";
import MtModalFull from "~/components/Modal/MtModalFull";
import MtModal from '~/components/Modal/MtModal'
import MtInput from '~/components/form/MtInput'
import ProfileGallery from '~/components/profile/ProfileGallery'
require("vue2-scrollbar/dist/style/vue2-scrollbar.css")
import { debounce } from '~/utils/utils';

export default {
  components: {
    ProfileGallery,
    MtInput,
    MtModal,
    Preloader,
    MasterpieceSelect,
    ProfileDetail,
    Settings,
    Button,
    LeftAside,
    ProfileAvatar,
    ProfileMenu,
    SidebarAnchors,
    MtModalFull,
    AchievementsModal
  },
  inject: ['$activeCommonBlocks'],
  data() {
    return {
      addMasterpieceOpened: false,
      openAchievements: false,
      openChangePassword: false,
      tabletAnchors: false,
      needShortText: false,
      contentLoaded: false,
      // myProfileData: null,
      passwordError: null,
      deleteError: null,
      passwordValues: {
        currentPassword: '',
        newPassword: '',
        retryPassword: ''
      },
      modal: false
    }
  },
  computed: {
    activeCommonBlocks() {
      return this.$activeCommonBlocks()
    },
    profileFullName() {
      const { name, surname } = this.myProfileData
      return `${name || ''} ${surname || ''}`
    },
    getLoyaltyProgramData(){
      return this.myProfileData.loyaltyProgramData
    },
    getCurrentAvailableCount() {
      const availableMirMasterpiecesCount = this.getLoyaltyProgramData.availableMirMasterpiecesCount || 0
      const addedMirMasterpieces = this.getLoyaltyProgramData.addedMirMasterpieces || 0
      return availableMirMasterpiecesCount - addedMirMasterpieces
    },
    myProfileData () {
      return this.getProfileDate.data ? this.getProfileDate.data.data : null
    },
    isVisibleBlock() {
      return (id) => {
        const array = this.activeCommonBlocks || []
        const item = array.find((elem) => elem.code === id);
        return item ? item.show : false
      }
    }
  },
  validate({ params }) {
    const linkVariables = ['detail', 'settings', 'gallery']
    return linkVariables.indexOf(params.section) !== -1
  },
  beforeMount () {
    if (window) {
      this.mediaQuery = window.matchMedia('(max-width: 1180px)')
      this.mediaQuery?.addEventListener ? this.mediaQuery.addEventListener('change', this.mediaHandler) : this.mediaQuery.addListener(this.mediaHandler)

      if (this.mediaQuery.matches) {
        this.tabletAnchors = true
      }
    }
  },
  beforeCreate() {
    if (!this.$cookies.get('token')) {
      this.$router.push({
        path: '/',
        query: {loginAsideOpen: true}
      })
    }
  },
  mounted (){
    if (this.needShortText && (window.innerWidth > 1599 || window.innerWidth <= 1180)) {
      this.needShortText = false
    } else if (!this.needShortText && (window.innerWidth < 1600 && window.innerWidth > 1180)) {
      this.needShortText = true
    }
    window.addEventListener("resize", this.checkTablet);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.checkTablet);
  },
  methods:{
    closeMasterpieceSelect() {
      if (this.$router.currentRoute.hash) {
        this.$router.replace({ hash: null })
      }
      this.addMasterpieceOpened = false
    },
    changePassword() {
      this.passwordError = null
      const { currentPassword, newPassword, retryPassword } = this.passwordValues
      if ( !currentPassword || !newPassword || !retryPassword) {
        const err = this.$t('profile.changePasswordAllFieldsError')
        this.passwordError = err
        return
      }
      if (newPassword !== retryPassword) {
        const err = this.$t('profile.changePasswordNotMatchError')
        this.passwordError = err
      } else {
        this.$axios({
          method: 'post',
          url: '/api/v1/personnel/update/',
          data: `password=${newPassword}&old_password=${currentPassword}&lang=${this.$i18n.locale || 'ru'}`
        })
        .then(({data}) => {
          if (data.error) {
            this.passwordError = data.error.message
          } else {
            this.myProfileData = data.data
            this.resetPassword()
            this.openChangePassword = false
          }
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
      }
    },
    resetPassword() {
      this.passwordValues = {
        currentPassword: '',
        newPassword: '',
        retryPassword: ''
      }
    },
    edit(value) {
      this.myProfileData = value
    },
    closePopup(){
      this.addMasterpieceOpened = false
    },
    openPopup(){
      this.addMasterpieceOpened = true
      this.openAchievements = false
    },
    currentNumber(num) {
      return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ₽' : '0 ₽'
    },
    checkTablet: debounce(function() {
      if (this.mediaQuery.matches) {
        this.tabletAnchors = true
      } else {
        this.tabletAnchors = false
      }

      if (this.needShortText && (window.innerWidth > 1599 || window.innerWidth <= 1180)) {
        this.needShortText = false
      } else if (!this.needShortText && (window.innerWidth < 1600 && window.innerWidth > 1180)) {
        this.needShortText = true
      }
    }, 50),
    deleteAccount() {
      this.deleteError = null
      this.$axios({
        method: 'post',
        url: '/api/v1/personnel/delete/'
      })
        .then(({data}) => {
          if (data.error) {
            this.deleteError = data.error.message
          } else {
            this.$cookies.remove('token')
            window.location.href = '/app'
          }
        })
        .catch(err => {
          console.log('ошибка при удалении аккаунта', err)
        })
    }
  },
  head() {
    const seo = this.getSeo?.data?.data || {}
    let title = seo.title
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }

    return {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords }
      ]
    }
  },
  chimera: {
    getSeo () {
      return {
        url: `/api/v1/seo/getByCode`,
        key: `page-seo-profile-${this.$route.params.section}-${this.$cookies.get('token') || ''}`,
        params: {
          code: `profile-${this.$route.params.section}`,
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getProfileDate () {
      return {
        url: '/api/v1/personnel/get/',
        key: `get-personnel-data-${this.$cookies.get('token') || ''}`,
        auto: true,
        prefetch: false,
        params: {
          lang: this.$i18n.locale || 'ru'
        },
        // on: {
        //   success () {
        //     this.myProfileData = this.getProfileDate.data.data
        //   }
        // }
      }
    }
  }
}
